import $ from 'jquery';
import {share} from '../api/api';
import isViewport from '../../scripts/util/window/isViewport';
import {lg, sm} from '../../scripts/util/window/isViewport';
import checkKey from '../../scripts/util/event/checkKey';

export default class Share {
	constructor() {
		this.selectors = {
			el: '.js-share-form',
			icon: '.js-icon-mail',
			close: '.js-share-close',
			triangle: '.js-share-triangle',
			social: '.js-social-share',
			submit: '.js-share-submit',
			status: '.js-share-status',
			message: '.js-share-message',
			messageText: '.js-message-text'
		};

		this.classes = {
			share: {
				visible: 'share_state_visible',
				active: 'social__icon_state_active',
				success: 'share_state_success'
			},
			message: {
				visible: 'message_state_visible'
			}

		};

		this.$el = $(this.selectors.el);
	}

	open = e => {
		const $target = $(e.currentTarget);
		const $social = $target.closest(this.$social);
		this.$el.addClass(this.classes.share.visible);
		this.$icon.addClass(this.classes.share.active);
		this.setPos($social);
		this.setTrianglePos($target);
	}

	close = () => {
		this.$el.removeClass(this.classes.share.visible);
		this.$el.removeClass(this.classes.share.success);
		this.$icon.removeClass(this.classes.share.active);
	}

	closeOnEsc = e => {
		if (checkKey(e)) {
			this.close();
		}
	}

	clickOutside = parent => e => {
		const $target = $(e.target);
		const isParent = $target.closest(parent).length || $target.hasClass('js-icon-mail') || $target.closest(this.$icon).length;
		if (!isParent) {
			this.close();
		}
	}

	submit = e => {
		e.preventDefault();
		const $target = $(e.target);
		const $data = $target.serialize();
		share($data).then(
			res => this.showMessage(JSON.parse(res).message),
			error => {
				this.showMessage('Ошибка при выполнении запроса');
				throw error;
			}
		);
	}

	showMessage(text) {
		const success = this.classes.share.success;
		const visible = this.classes.message.visible;
		if (isViewport(lg)) {
			this.$message.addClass(visible);
			this.$message.find(this.selectors.messageText).text(text);
			this.close();
			setTimeout(() => this.$message.removeClass(visible), 4000);
		} else {
			this.$el.addClass(success);
			this.$el.find(this.selectors.status).text(text);
			setTimeout(this.close, 4000);
		}
	}

	setPos(el) {
		if (el.length && isViewport(sm)) {
			const left = el.position().left;
			this.$el.css({left});
		} else {
			this.$el.attr('style', '');
		}
	}

	setTrianglePos(el) {
		const targetLeft = el.offset().left;
		const targetWidth = el.width();
		const elLeft = this.$el.offset().left;
		const pos = ((targetLeft - elLeft) + targetWidth / 3) - 1;
		this.$triangle.css({left: pos});
	}

	setHandlers() {
		this.$icon.on('click', this.open);
		this.$close.on('click', this.close);
		this.$el.on('submit', this.submit);
		this.$document.on('keydown', this.closeOnEsc);
		this.$document.on('click', this.clickOutside(this.$el));
		this.$window.on('resize', () => {
			this.setPos(this.$social);
			this.setTrianglePos(this.$icon);
		});
	}

	getDom() {
		this.$icon = $(this.selectors.icon);
		this.$close = $(this.selectors.close);
		this.$triangle = $(this.selectors.triangle);
		this.$social = $(this.selectors.social);
		this.$submit = $(this.selectors.submit);
		this.$message = $(this.selectors.message);

		this.$window = $(window);
		this.$document = $(document);
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.setHandlers();
		}
	}

}



/** WEBPACK FOOTER **
 ** ./app/blocks/share/share.js
 **/